/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { Grid } from '@theme-ui/components'
import { graphql, useStaticQuery } from 'gatsby'
import { IoMdPin } from 'react-icons/io'
import { MdPhoneInTalk } from 'react-icons/md'
import { ReactSVG } from 'react-svg'
import { jsx } from 'theme-ui'
import { Box, Col, Container, Heading, NavLink, Text } from './elements'
import Logo from './Logo'
import { Socials } from './socialButtons'

const List = ({ ...props }) => (
  <ol
    {...props}
    // eslint-disable-next-line react/no-unknown-property
    sx={{
      listStyle: 'none',
      pt: 3,
      pb: 5,
    }}
  />
)
const FooterLink = ({ ...props }) => (
  <NavLink
    {...props}
    sx={{
      color: 'gray',
    }}
  />
)
const ListHeading = ({ ...props }) => (
  <Heading
    {...props}
    sx={{
      color: 'dark',
      fontSize: [4],
      textTransform: 'uppercase',
      textAlign: 'center',
      mb: [3],
    }}
  />
)
const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      allWpMenuItem(filter: { locations: { eq: ROOFING_MENU }, parentDatabaseId: { eq: 0 } }) {
        nodes {
          url
          label
          childItems {
            nodes {
              url
              label
            }
          }
        }
      }

      file(relativePath: { eq: "nexvel-logo.svg" }) {
        publicURL
      }
    }
  `)
  const menus = data.allWpMenuItem.nodes.map((menu, i) => {
    return (
      // eslint-disable-next-line react/no-array-index-key
      <Box key={i} mx="auto">
        <ListHeading>{menu.label} </ListHeading>
        <Grid columns={[2, 2, 1]}>
          {menu.childItems.nodes.map((child, idx) => (
            <FooterLink
              // eslint-disable-next-line react/no-array-index-key
              key={idx}
              to={child.url.replace(`https://wordpress-321502-1056842.cloudwaysapps.com`, ``)}
            >
              {' '}
              {child.label}{' '}
            </FooterLink>
          ))}
        </Grid>
      </Box>
    )
  })
  return (
    <footer
      // eslint-disable-next-line react/no-unknown-property
      sx={{
        fontSize: 1,
        variant: 'styles.footer',
        py: [3, 4],
      }}
    >
      <Container maxWidth={1300}>
        <Grid
          columns={[1, 1, 4]}
          sx={{
            px: 4,
            pb: 5,
          }}
        >
          <Col width={[300]} mx="auto">
            <Logo />
            <Text color="gray" mt={3}>
              At Phil DiBello Family Roofing, we rely on our strong backbone of experience and
              knowledge to maintain our reputation
            </Text>
            <Socials sx={{ color: 'gray', fontSize: [4, 5], svg: { mx: [1, 2] } }} />
          </Col>
          {menus}
          <Box sx={{ color: 'gray' }}>
            <ListHeading>ADDRESS </ListHeading>
            <List
              sx={{
                li: {
                  display: 'flex',
                  my: 2,
                  maxWidth: 220,
                  svg: {
                    mr: 2,
                    fill: 'primary',
                  },
                },
              }}
            >
              <li>
                {' '}
                <a
                  href="https://www.google.com/maps/dir//1440+E+Clement+St,+Baltimore,+Maryland+21230/@39.270677,-76.595389,17z/data=!3m1!4b1!4m9!4m8!1m0!1m5!1m1!1s0x89c8039ddb68ddf9:0xd335c4db566c60ee!2m2!1d-76.593195!2d39.270677!3e3"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <IoMdPin sx={{ width: '30px', height: '30px', float: 'left' }} /> 1440 E Clement
                  St Baltimore, Maryland 21230
                </a>
              </li>
              <li>
                {' '}
                <MdPhoneInTalk /> <a href="tel:410-752-7663">PHONE: 410-752-7663</a>
              </li>
            </List>
          </Box>
        </Grid>
      </Container>
      <div
        // eslint-disable-next-line react/no-unknown-property
        sx={{
          display: 'flex',
          justifyContent: 'space-evenly',
          p: [2, 3],
          color: 'gray',
          textAlign: 'center',
        }}
      >
        <FooterLink to="/privacy-policy" sx={{ color: 'inherit' }}>
          Privacy Policy
        </FooterLink>
        <br />
        <FooterLink to="/site-map" sx={{ color: 'inherit' }}>
          Site Map
        </FooterLink>
        <div style={{ textAlign: 'center' }}>
          <a href="https://www.nexvelsolutions.com/" rel="noopener noreferrer" target="_blank">
            Website Designed by Nexvel Solutions <br />
            <br />
            <ReactSVG src={data.file.publicURL} />
          </a>
        </div>
        <br />© 2020 Phil DiBello Roofing
      </div>
    </footer>
  )
}

export default Footer
